/*
 * Arabic (ar) live search dropdown.
 *
 * The native predictive endpoint (/ar/search/suggest) returns
 * 417 "Unsupported buyer locale" for Arabic, so this fetches results from the
 * working /ar/search endpoint via the Section Rendering API and shows them in a
 * dropdown that reuses the theme's existing .predictive-search styles.
 *
 * Attaches to any <form data-ar-predictive>.
 */
(function () {
  'use strict';

  function searchUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/search';
  }

  function initForm(form) {
    if (form.dataset.arpsReady) return;
    form.dataset.arpsReady = 'true';

    var input = form.querySelector('input[name="q"]');
    var field = form.querySelector('.field') || form;
    if (!input) return;

    var results = document.createElement('div');
    results.className = 'predictive-search predictive-search--search-template';
    results.setAttribute('tabindex', '-1');
    // .predictive-search is display:none by default (only shown inside the native
    // <predictive-search> element). We control visibility with an inline style,
    // which overrides the stylesheet rule.
    results.style.display = 'none';
    field.appendChild(results);

    var debounce, controller, lastQuery = '';
    var SPINNER =
      '<div class="predictive-search__loading-state" style="display:block">' +
      '<svg class="spinner loading-overlay__spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

    function close() {
      results.style.display = 'none';
      results.innerHTML = '';
    }

    function run(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.innerHTML = SPINNER;
      results.style.display = 'block';

      var url =
        searchUrl() +
        '?q=' + encodeURIComponent(query) +
        '&type=product,page,article&section_id=predictive-search-ar';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || !html.trim()) { close(); return; }
          results.innerHTML = html;
          results.style.display = 'block';
        })
        .catch(function (e) { if (e.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounce);
      if (query.length < 1) { lastQuery = ''; close(); return; }
      if (query === lastQuery && results.style.display === 'block') return;
      lastQuery = query;
      debounce = setTimeout(function () { run(query); }, 300);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 1 && results.innerHTML) results.style.display = 'block';
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function initAll() {
    var forms = document.querySelectorAll('form[data-ar-predictive]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  // Re-scan when the theme editor reloads a section.
  document.addEventListener('shopify:section:load', initAll);
})();
